export default {
  uploadedHomeworks: [],
  isUploadedHomeworksSent: false,
  officeUploadedHomeworks: [],
  isOfficeUploadedHomeworksSent: false,
};
